import React from 'react';
import { motion } from 'framer-motion';
import { YouTubeEmbed } from './YouTubeEmbed';
export function VideoSection() {
  return <section className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-391" data-mp="18vrup43wj8ux">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-392" data-mp="1nsivnht84smn" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-393" data-mp="1iso3zc1mjz0j" />
      <div className="relative z-10 mx-auto max-w-[1100px]" data-id="element-394" data-mp="1ir3dbxifl07y">
        <div className="mb-10" data-id="element-395" data-mp="1wr4bv6b83vk9">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5
        }} className="font-heading text-4xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-5xl" data-id="element-396" data-mp="1wqct4w2q5sbe">
            Ein Einblick in unsere{' '}
            <span className="block text-hot-500" data-id="element-397" data-mp="2fjgp4o3f0h96">Sales Mastermind</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="mt-6 text-sm leading-relaxed text-neutral-600 sm:text-base" data-id="element-398" data-mp="2bi3jof48ig2s">
            <span className="block" data-id="element-399" data-mp="13ssbvgh30nhu">
              Stell dir vor, du kannst von überall auf der Welt arbeiten – mit nichts weiter als
              deinem Smartphone und einer Internetverbindung. Dein Kalender füllt sich mit
              vorqualifizierten Interessenten, mit denen du deine Gespräche führst.
            </span>
            <span className="mt-3 block" data-id="element-400" data-mp="1hrs04n0on0dh">
              Dein einziger Job – Du führst Gespräche authentisch und auf Augenhöhe und
              entscheidest selbst, von wo aus du arbeitest: am Pool, auf dem Sofa oder von deinem
              Lieblingsort irgendwo auf der Welt.
            </span>
            <span className="mt-3 block" data-id="element-401" data-mp="1wh7lfnhg2dls">
              Das ist mehr als nur Sales. Unsere Sales Mastermind in Dubai zeigt, was entsteht, wenn
              ambitionierte Frauen mit großen Zielen zusammenkommen: neue Verbindungen, neue
              Perspektiven, Wachstum und Momente, die bleiben. Ein Einblick in die Welt der Hot
              Sales Girls – und in das, was möglich wird, wenn du dich für mehr entscheidest.
            </span>
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative aspect-video w-full overflow-hidden rounded-3xl shadow-2xl" data-id="element-402" data-mp="1grrpqoarirqw">
          <YouTubeEmbed videoId="3Zg3k9r6lNQ" title="Ein Einblick in unsere Sales Mastermind in Dubai – Hot Sales Girls Academy" data-id="element-403" data-mp="1zjkhygi0c8xk" />
        </motion.div>
      </div>
    </section>;
}